import styled, { css } from 'styled-components';

export const Container = styled.div<{ withBackground: boolean }>`
  ${({ withBackground }) => css`
    position: fixed;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: var(--height-full);
    background: ${withBackground ? '#fff' : '#00000075'};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    svg {
      width: 100px;
    }

    p {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }
  `}
`;
